var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Animation } from '../../../../lib/classes/animation';
import { roundRect } from '../../../../lib/utils';
var TimerEffect = /** @class */ (function (_super) {
    __extends(TimerEffect, _super);
    function TimerEffect(props) {
        return _super.call(this, props) || this;
    }
    TimerEffect.prototype.upd = function (dt) {
        if (this.props.speed) {
            dt *= this.props.speed;
        }
        this.time += dt;
    };
    TimerEffect.prototype.isDone = function () {
        return this.props.time < this.time;
    };
    TimerEffect.prototype.draw = function (scene) {
        if (this.props.mask) {
            scene.fillAll(this.props.mask);
        }
        var time = Math.max(0, Math.ceil((this.props.time - this.time) / 1000));
        var y = scene.height / 2 - 50;
        scene.font(15);
        var text = this.props.text.replace('$t', String(time));
        this.width = this.width || scene.textWidth(text) + 20;
        var x = (scene.width - this.width) / 2;
        roundRect(scene, x, y - 25, this.width, 45, 5, 'rgba(49,46,43,0.85)');
        scene.fillStyle('#fff');
        scene.fillCenterText(text, y);
    };
    return TimerEffect;
}(Animation));
export { TimerEffect };
